/**
 * @generated SignedSource<<6e225207a45f6dd22f083e0b3de993b8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type appStateQuery$variables = {
  skipRequest: boolean;
};
export type appStateQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AppLeftSidebarBottomFragment" | "appSubscriptionCheck" | "defaultLayoutContainerPriceFormatterSupplierFragment" | "defaultLayoutContainerSellerLastUsedToolFragment" | "profitWellFragment" | "tagManagerFragment" | "useAccountDataFragment" | "useShouldAcceptTermsAndConditionsDialogFragment" | "usetifulFragment">;
};
export type appStateQuery = {
  response: appStateQuery$data;
  variables: appStateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skipRequest"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userID",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "remoteUrl",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "environment",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "appStateQuery",
    "selections": [
      {
        "condition": "skipRequest",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "appSubscriptionCheck"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "defaultLayoutContainerPriceFormatterSupplierFragment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "defaultLayoutContainerSellerLastUsedToolFragment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "useAccountDataFragment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "profitWellFragment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "usetifulFragment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "tagManagerFragment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AppLeftSidebarBottomFragment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "useShouldAcceptTermsAndConditionsDialogFragment"
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "appStateQuery",
    "selections": [
      {
        "condition": "skipRequest",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAdminUser",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ZakekeSubscription",
            "kind": "LinkedField",
            "name": "subscription",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isCancelled",
                "storageKey": null
              },
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EcommerceSettings",
            "kind": "LinkedField",
            "name": "ecommerceSettings",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currencyCode",
                "storageKey": null
              },
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ecommerceID",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sellerLastUsedTool",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "OverviewSubscription",
            "kind": "LinkedField",
            "name": "overviewSubscription",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sellerAppsumoMarketPlaceID",
                "storageKey": null
              },
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserInfo",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              (v4/*: any*/),
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SellerStaticsDetail",
            "kind": "LinkedField",
            "name": "sellerStaticsDetails",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "state",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "subState",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "username",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "registeredOn",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "subscribedOn",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "configuredOn",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "planName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "orders",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ordersAsPaying",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "quantity",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "amount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "interactions",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "products",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "designs",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "printfulProducts",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "printfulOrders",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastDayOrders",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastOrderDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalFees",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "previousDayItemsOrdered",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "countryID",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userSource",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "privacy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isExtraViews",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "identityProviderId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "integrationState",
                "storageKey": null
              },
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeMenuReferringInfo",
            "kind": "LinkedField",
            "name": "treeMenuReferringInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isSubscriptionSubStatusBlocked",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "noValidSubscriptionReason",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "subscriptionCancel",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isTrial",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "daysOfTrial",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstNotPublishedProductID",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasFirstCustomizableProduct",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPublishedProduct",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasStoreConnected",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isAdministrator",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isComposerEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isExternalLinksHidden",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isHelpWidgetHidden",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isMenuHidden",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isNoViewsPlan",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isSubscriptionCanceled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isToolbarHidden",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isVisibleSubscribePlan",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "planVersion",
                "storageKey": null
              },
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sellerAppsumoMarketplaceID",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "toolbarForceTools",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "urlComposer",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isSellerMigrating",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SellerSetting",
            "kind": "LinkedField",
            "name": "sellerSetting",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userInterfaceSwitchType",
                "storageKey": null
              },
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 50
              }
            ],
            "concreteType": "SellerUserInterfacesConnection",
            "kind": "LinkedField",
            "name": "sellerUserInterfaces",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SellerUserInterface",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "settings",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isDefault",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userInterfaceId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sellerUserInterfaceId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "sellerUserInterfaces(first:50)"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ShopifyAuthEcommerceSettings",
            "kind": "LinkedField",
            "name": "shopifyAuthEcommerceSettings",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "installed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isTestStore",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "shop",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "status",
                "value": "ACTIVE"
              }
            ],
            "concreteType": "SalesChannel",
            "kind": "LinkedField",
            "name": "salesChannels",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SalesChannelDetail",
                "kind": "LinkedField",
                "name": "detail",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SalesChannelDetailProperties",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EcommerceSettings",
                "kind": "LinkedField",
                "name": "ecommerceSettings",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ecommerceGlobalID",
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isMarketplace",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "definitiveUrl",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "salesChannels(status:\"ACTIVE\")"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "countryISOCode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sellerIP",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "testOrdersCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shouldAcceptTermsAndConditions",
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "0e3fbd9d0fa4450253bdec776090cd0c",
    "id": null,
    "metadata": {},
    "name": "appStateQuery",
    "operationKind": "query",
    "text": "query appStateQuery(\n  $skipRequest: Boolean!\n) {\n  ...appSubscriptionCheck @skip(if: $skipRequest)\n  ...defaultLayoutContainerPriceFormatterSupplierFragment @skip(if: $skipRequest)\n  ...defaultLayoutContainerSellerLastUsedToolFragment @skip(if: $skipRequest)\n  ...useAccountDataFragment @skip(if: $skipRequest)\n  ...profitWellFragment @skip(if: $skipRequest)\n  ...usetifulFragment @skip(if: $skipRequest)\n  ...tagManagerFragment @skip(if: $skipRequest)\n  ...AppLeftSidebarBottomFragment @skip(if: $skipRequest)\n  ...useShouldAcceptTermsAndConditionsDialogFragment @skip(if: $skipRequest)\n}\n\nfragment AppLeftSidebarBottomFragment on Query {\n  user {\n    userID\n    email\n    name\n    id\n  }\n  testOrdersCount\n  treeMenuReferringInfo {\n    daysOfTrial\n    firstNotPublishedProductID\n    hasFirstCustomizableProduct\n    hasPublishedProduct\n    hasStoreConnected\n    isAdministrator\n    isComposerEnabled\n    isExternalLinksHidden\n    isHelpWidgetHidden\n    isMenuHidden\n    isNoViewsPlan\n    isSubscriptionCanceled\n    isSubscriptionSubStatusBlocked\n    isToolbarHidden\n    isTrial\n    isVisibleSubscribePlan\n    noValidSubscriptionReason\n    planVersion\n    remoteUrl\n    sellerAppsumoMarketplaceID\n    subscriptionCancel\n    toolbarForceTools\n    urlComposer\n    userType\n  }\n}\n\nfragment appSubscriptionCheck on Query {\n  isAdminUser\n  subscription {\n    isCancelled\n    id\n  }\n}\n\nfragment defaultLayoutContainerPriceFormatterSupplierFragment on Query {\n  ecommerceSettings {\n    currencyCode\n    id\n  }\n}\n\nfragment defaultLayoutContainerSellerLastUsedToolFragment on Query {\n  sellerLastUsedTool\n}\n\nfragment profitWellFragment on Query {\n  treeMenuReferringInfo {\n    userType\n  }\n}\n\nfragment tagManagerFragment on Query {\n  treeMenuReferringInfo {\n    isTrial\n    noValidSubscriptionReason\n    subscriptionCancel\n  }\n  ecommerceSettings {\n    currencyCode\n    id\n  }\n  countryISOCode\n  sellerIP\n}\n\nfragment useAccountDataFragment on Query {\n  ecommerceSettings {\n    ecommerceName\n    ecommerceID\n    id\n  }\n  overviewSubscription {\n    sellerAppsumoMarketPlaceID\n    id\n  }\n  user {\n    userID\n    email\n    name\n    id\n  }\n  sellerStaticsDetails {\n    userID\n    state\n    subState\n    username\n    registeredOn\n    subscribedOn\n    configuredOn\n    planName\n    orders\n    ordersAsPaying\n    quantity\n    amount\n    interactions\n    products\n    designs\n    printfulProducts\n    printfulOrders\n    lastDayOrders\n    lastOrderDate\n    totalFees\n    previousDayItemsOrdered\n    countryID\n    userSource\n    privacy\n    isExtraViews\n    identityProviderId\n    integrationState\n    id\n  }\n}\n\nfragment useShouldAcceptTermsAndConditionsDialogFragment on Query {\n  shouldAcceptTermsAndConditions\n}\n\nfragment usetifulFragment on Query {\n  isSellerMigrating\n  treeMenuReferringInfo {\n    isSubscriptionSubStatusBlocked\n    noValidSubscriptionReason\n    subscriptionCancel\n    isTrial\n  }\n  sellerSetting {\n    userInterfaceSwitchType\n    id\n  }\n  sellerUserInterfaces(first: 50) {\n    nodes {\n      id\n      environment\n      settings\n      isDefault\n      url\n      userInterfaceId\n      sellerUserInterfaceId\n    }\n  }\n  shopifyAuthEcommerceSettings {\n    environment\n    installed\n    isTestStore\n    shop\n  }\n  salesChannels(status: ACTIVE) {\n    id\n    detail {\n      id\n      properties {\n        name\n      }\n    }\n    ecommerceSettings {\n      id\n      ecommerceGlobalID\n      ecommerceName\n      remoteUrl\n      isMarketplace\n      definitiveUrl\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0e2bc473bf1e458cd9e454bfe8b98069";

export default node;
